import { useSelector } from 'react-redux';
import { TranslatableObjectKey } from 'hooks/redux/Translatable/useTranslatableLanguages';

const useGetConsentsDataFromBrandTerm = () => {
  const { clientLanguages } = useSelector(({ Auth }) => Auth);

  return ({
    '@id': iri,
    consent,
    active,
    additionalInfo,
    additionalContent,
  }) => ({
    id: iri.split('/').pop(),
    consent: clientLanguages.reduce(
      (accumulator, { isoCode }) => ({
        ...accumulator,
        [isoCode]: consent[TranslatableObjectKey][isoCode] || '',
      }),
      {}
    ),
    active,
    additionalInfo,
    additionalContent: clientLanguages.reduce(
      (accumulator, { isoCode }) => ({
        ...accumulator,
        [isoCode]: additionalContent[TranslatableObjectKey][isoCode] || '',
      }),
      {}
    ),
  });
};

export default useGetConsentsDataFromBrandTerm;
